import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

declare var gtag: Function;

interface AnalyticObject {
  event: any;
  page_type: any;
  product_type: any;
  event_context?: any;
  items?:Object;
  email?: any; 
}

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor(private router: Router) {

  }

  public sendCustomEvent(paramsObj: AnalyticObject): void {
      gtag('set',paramsObj);
  }

  public sendPageViewEvent(eventName: string, pageType: any): void {
    gtag('set',{'event':eventName, 'page_type': pageType});
  }
 
  createAnalyticObject(event, pageType, productType, eventContext, items, email)
  {
    const analyticObject : AnalyticObject = {
      event: event,
      page_type: pageType,
      product_type: productType,
    };
    if (eventContext)
    {
      analyticObject.event_context = eventContext;
    }
  
    if (email) {
      analyticObject.email = email;
    }
    if (items)
    {
      analyticObject.items = items;
    }
  
    return analyticObject;
  }
}